// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-account-creation-container[data-v-d422fde4]{display:block;width:100%;clear:both;min-height:1rem}[data-v-d422fde4] .form-row-inner-container{text-align:left;grid-template-columns:25% 65%}", ""]);
// Exports
module.exports = exports;
